/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Optional_LabelInputs */

const en_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`optional`)
};

const fr_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`facultatif`)
};

const de_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`optional`)
};

const it_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opzionale`)
};

const ru_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`необязательный`)
};

const es_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opcional`)
};

const zh_cn2_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选修的`)
};

const ja_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オプション`)
};

const hi_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वैकल्पिक`)
};

const pt_pt2_team_sync_optional_label = /** @type {(inputs: Team_Sync_Optional_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`opcional`)
};

/**
* | output |
* | --- |
* | "optional" |
*
* @param {Team_Sync_Optional_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_optional_label = /** @type {((inputs?: Team_Sync_Optional_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Optional_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_optional_label(inputs)
	if (locale === "de") return de_team_sync_optional_label(inputs)
	if (locale === "it") return it_team_sync_optional_label(inputs)
	if (locale === "ru") return ru_team_sync_optional_label(inputs)
	if (locale === "es") return es_team_sync_optional_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_optional_label(inputs)
	if (locale === "ja") return ja_team_sync_optional_label(inputs)
	if (locale === "hi") return hi_team_sync_optional_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_optional_label(inputs)
	return en_team_sync_optional_label(inputs)
});